<template>
<div class="main-body">
  <b-alert
    dismissible
    :show="showDismissibleAlert"
    :variant="alertVariant"
    @dismissed="showDismissibleAlert=false">{{ alertMessage }}</b-alert>
    <form>
      <div class="card">
          <div class="card-body">
              <div class="row">
                  <div class="col-sm-5">
                      <h4 class="card-title mb-0">
                        Book In RMA {{ rmaProduct.document_no }}
                      </h4>
                  </div><!--col-->
                  <div class="col-sm-7">
                    <div class="btn-toolbar float-right" role="toolbar" aria-label="Toolbar with button groups">
                    </div><!--btn-toolbar-->
                  </div><!--col-->
              </div><!--row-->

              <div class="row mt-4">
                  <div class="col" >
                      <div class="form-group row">
                        <label for="conditions" class="col-sm-3 col-form-label">{{ $t('marketplace.rma_product.conditions') }}</label>
                        <div class="col-sm-6" v-bind:class="{'form-group--error': $v.rmaProduct.conditions.$error }">
                           <select class="form-control" v-model="rmaProduct.conditions" v-bind:class="containsErrorKey('conditions')">
                            <option value="" key="1">Please select a Condition</option>
                            <option value="Good Condition" key="2">Good Condition</option>
                            <option value="Like New" key="3">Like New</option>
                            <option value="Damage" key="4">Damage</option>
                          </select>
                        </div>
                        <div role="alert" aria-live="assertive" aria-atomic="true" class="invalid-feedback d-block">{{ validFailed.conditions }}</div>
                      </div>
                      <div class="form-group row">
                         <label for="warehouse_received_at" class="col-sm-3 col-form-label">{{ $t('marketplace.rma_product.warehouse_received_at') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.warehouseReceivedDate.$error }">
                          <input v-model="warehouseReceivedDate" type="date" name="warehouse_received_at" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="remark" class="col-sm-3 col-form-label">{{ $t('marketplace.rma_product.remark') }}</label>
                        <div class="col-sm-6">
                           <textarea rows="4" v-model.trim="rmaProduct.remark" type="text" name="remark" class="form-control" />
                        </div>
                      </div>
                  </div><!--col-->
              </div><!--row-->

              <div slot="footer">
                <div class="row">
                    <div class="col-3">
                      <div class="float-left"></div>
                    </div><!--col-->
                    <div class="col-5">
                      <b-button v-show="!showLoadingPanel" type="submit" size="sm" variant="primary" @click.stop.prevent="handleSubmit"><i class="fa fa-dot-circle-o"></i> {{ $t('marketplace.rma_product.submit') }}</b-button>
                    </div><!--col-->
                </div><!--row-->
              </div>
          </div><!--card-body-->
      </div><!--card-->
    </form>
   <loading-panel v-if="showLoadingPanel"></loading-panel>
  </div>
</template>
<script>

import { required } from 'vuelidate/lib/validators'
import loadingPanel from '@/components/LoadingPanel'
import moment from 'moment'

export default {
  name: 'AddRmaProductForm',
  props: {
    rmaProduct: {
      type: Object
    },
    callback: {
      type: Function
    }
  },
  components: {
    loadingPanel
  },
  data () {
    return {
      validFailed: {},
      warehouseReceivedDate: moment().format('YYYY-MM-DD'),
      showLoadingPanel: false,
      showDismissibleAlert: false,
      alertVariant: '',
      alertMessage: '',
      message: ''
    }
  },
  validations: {
    rmaProduct: {
      conditions: {
        required
      },
    },
    warehouseReceivedDate: {
      required
    },
  },
  methods: {
    containsErrorKey (key) {
      let result = Object.keys(this.validFailed).includes(key)
      if (result) {
        return 'is-invalid'
      }
    },
    handleSubmit () {
      console.log(" this.$v",  this.$v)
      this.$v.rmaProduct.$touch()
      // create store
      if (!this.$v.rmaProduct.$error) {
        // create rmaProduct
        let vm = this
        this.showLoadingPanel = true
        this.axios.post('/marketplace/rma-product/'+ this.rmaProduct.id +'/book-in', {
          conditions: this.rmaProduct.conditions,
          remark: this.rmaProduct.remark,
          warehouse_received_at: this.warehouseReceivedDate,
        }).then(response => {
        this.showLoadingPanel = false
        this.showAlert('success', vm.$t('marketplace.rma_product.success_message'))
        this.message = response.data
        setTimeout(() => {
          this.showDismissibleAlert = false
          this.callback()
        }, 2000);
      }).catch(error => {
        this.showLoadingPanel = false
         if(error.data.validations && Object.keys(error.data.validations).length > 0){
            let  errorMessage = ""
            for(var key of Object.keys(error.data.validations)) {
              errorMessage = key +": "
              error.data.validations[key].forEach(element => {
                errorMessage += element
              });
            }
            this.showAlert('danger', errorMessage)
          }
          if(error.data.message){
              this.showAlert('danger', error.data.message)
          }
      })
      }
    },
    format (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    showAlert (alertVariant, message) {
      this.showDismissibleAlert = true
      this.alertVariant = alertVariant
      this.alertMessage = message
    }
  }
}
</script>
